import React from 'react';
import InternalPhoto from '../InternalPhoto';

const PageHeader = ({ title, subtitle, internalDetails }) => {
  const formatValue = (value) => {
    if (!value) return '';
    if (Array.isArray(value)) return value.filter(Boolean).join(', ');
    return value;
  };

  const formatDatePtBr = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('pt-BR');
  };

  const arrivalValue =
    internalDetails?.arrival ||
    internalDetails?.arrival_date ||
    internalDetails?.entry_date;

  const chips = [
    { label: 'Entrada na unidade', value: formatDatePtBr(arrivalValue) },
    { label: 'Unidade', value: internalDetails?.unit_acronym },
    { label: 'Pavilhão', value: internalDetails?.pavilion_name },
    { label: 'Cela', value: internalDetails?.cell_name },
  ].filter((item) => item.value);


  return (
    <>
      <div className="admission-header">
        <div className="admission-title">
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {chips.length > 0 && (
          <div className="admission-chips">
            {chips.map((chip) => (
              <span key={chip.label} className="admission-chip">
                {chip.label}: {formatValue(chip.value)}
              </span>
            ))}
          </div>
        )}
      </div>

      <section className="admission-hero">
        <div className="admission-hero-avatar">
          <InternalPhoto internal={internalDetails} alt={internalDetails?.name || 'Foto interno'} />
        </div>
        <div className="admission-hero-content">
          <div className="admission-hero-row admission-hero-row--3">
            <div className="admission-info-item">
              <span>Nome</span>
              <strong>{formatValue(internalDetails?.name)}</strong>
            </div>
            <div className="admission-info-item">
              <span>Nome da mãe</span>
              <strong>{formatValue(internalDetails?.mothers_name)}</strong>
            </div>
            <div className="admission-info-item">
              <span>Vulgo</span>
              <strong>{formatValue(internalDetails?.aka)}</strong>
            </div>
          </div>
          <div className="admission-hero-row admission-hero-row--2">
            <div className="admission-info-item">
              <span>CPF</span>
              <strong>{formatValue(internalDetails?.cpf)}</strong>
            </div>
            <div className="admission-info-item">
              <span>Nascimento</span>
              <strong>{formatDatePtBr(internalDetails?.date_of_birth)}</strong>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PageHeader;
